import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { A11yModule } from '@angular/cdk/a11y';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatSortModule } from '@angular/material/sort';
import { MatMenuModule } from '@angular/material/menu';
import {
  MatTooltipDefaultOptions,
  MatTooltipModule,
  MAT_TOOLTIP_DEFAULT_OPTIONS,
} from '@angular/material/tooltip';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { TippyModule } from '@ngneat/helipopper';
import { ColorCircleModule } from 'ngx-color/circle';

import { GridComponent } from './grid.component';
import { ColorPickerMenuComponent } from './components/color-picker-menu/color-picker-menu.component';
import { MandatoryTextComponent } from './components/display/mandatory-text/mandatory-text.component';
import { MandatoryDateComponent } from './components/display/mandatory-date/mandatory-date.component';
import {
  CheckboxEditComponent,
  ConfirmationDialogComponent,
  DeleteButtonComponent,
  NumericEditComponent,
  SelectDisplayComponent,
  SelectEditComponent,
  TextDisplayComponent,
  TextEditComponent,
  TooltipMessageComponent,
  ColorPickerComponent,
  DateDisplayComponent,
  DateEditComponent,
  FilterTextEditComponent,
  FilterSelectEditComponent,
} from './components';
import {
  FindByPropertyPipe,
  CssPixelValuePipe,
  TruncateTextPipe,
  MapByPropertyPipe,
  ArrayIncludesPipe,
  AnyFnExecPipe,
  SumPipe,
  TooltipDisabledPipe,
  GroupHasDataPipe,
  FilterByPropertyPipe,
} from './pipes';
import {
  AutofocusDirective,
  GridCellDefDirective,
  NumericInputDirective,
  NgLetDirective,
  StickyTableHeaderDirective,
  MorphingButtonDirective,
  FilterCellDefDirective,
  ColumnDynamicWidthDirective,
} from './directives';
import { FocusManagerService, RefreshService } from './services';
import { ColorService } from './services/color.service';
import { SvgIconsModule } from './svg-icons/svg-icons.module';

export const myCustomTooltipDefaults: MatTooltipDefaultOptions = {
  showDelay: 0,
  hideDelay: 0,
  touchendHideDelay: 1500,
  disableTooltipInteractivity: true,
};

@NgModule({
  declarations: [
    GridComponent,
    TextDisplayComponent,
    SelectDisplayComponent,
    DateDisplayComponent,
    TextEditComponent,
    SelectEditComponent,
    CheckboxEditComponent,
    NumericEditComponent,
    DateEditComponent,
    DeleteButtonComponent,
    ConfirmationDialogComponent,
    TooltipMessageComponent,
    ColorPickerComponent,
    FindByPropertyPipe,
    FilterByPropertyPipe,
    GroupHasDataPipe,
    AnyFnExecPipe,
    CssPixelValuePipe,
    TruncateTextPipe,
    MapByPropertyPipe,
    ArrayIncludesPipe,
    GridCellDefDirective,
    FilterCellDefDirective,
    AutofocusDirective,
    NumericInputDirective,
    StickyTableHeaderDirective,
    SumPipe,
    NgLetDirective,
    TooltipDisabledPipe,
    MorphingButtonDirective,
    ColumnDynamicWidthDirective,
    ColorPickerMenuComponent,
    FilterTextEditComponent,
    FilterSelectEditComponent,
    MandatoryTextComponent,
    MandatoryDateComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatTableModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatSortModule,
    MatMenuModule,
    MatTooltipModule,
    A11yModule,
    NgxMatSelectSearchModule,
    MatTooltipModule,
    SvgIconsModule,
    DragDropModule,
    TippyModule,
    MatDatepickerModule,
    ColorCircleModule,
  ],
  exports: [
    GridComponent,
    TextDisplayComponent,
    SelectDisplayComponent,
    TextEditComponent,
    SelectEditComponent,
    CheckboxEditComponent,
    NumericEditComponent,
    DeleteButtonComponent,
    AutofocusDirective,
    MorphingButtonDirective,
  ],
})
export class GridModule {
  static forRoot(): ModuleWithProviders<GridModule> {
    return {
      ngModule: GridModule,
      providers: [
        FocusManagerService,
        RefreshService,
        ColorService,
        {
          provide: MAT_TOOLTIP_DEFAULT_OPTIONS,
          useValue: myCustomTooltipDefaults,
        },
      ],
    };
  }
}
